import {useRedPill} from "Hooks/api/useRedPill";
import useModal from "Hooks/useModal";
import useAxios from "Setup/axios";
import {LOGIN_URL} from "Setup/urls";
import {setLoginError} from "Redux/actions/ui";
import {useDispatch} from "react-redux";
import {useHistory, useLocation} from "react-router-dom";
import {useRef, useState} from "react";
import {sendGA4Event} from "Helpers/gaEvents";


const getTemporaryTerms = (username) => (`
<p>Dear ${username}</p>
<p>We are amending our General Terms and Conditions, Promotional Terms and our Privacy Notice.</p>
<p>To review the amended terms in advance of their taking effect on our legal relationship please click see <a href="/terms-and-conditions" target="_blank">General T&Cs</a> and <a href="/promotional-terms" target="_blank">Promotional T&Cs</a> and <a href="/privacy-policy" target="_blank">Privacy Notice</a>.</p>
<p>By proceeding to play on Our Website you are accepting and agreeing to these amendments to our Terms and Conditions carrying forward from such time.</p>
<p>Please contact customer support if you have any queries.</p>
`);

export function useLogin() {
    const location = useLocation();
    const dispatch = useDispatch();
    const history = useHistory();
    const {instance} = useAxios();
    const {execute, status, value, error} = useRedPill("login");
    const {openModal, closeModal} = useModal();
    const [loginDetails, setLoginDetails] = useState({username: "", password: ""});

    const formStateRef = useRef();
    formStateRef.current = loginDetails;

    const acceptTermsLogin = () => {
        const {username, password} = formStateRef.current;
        login(username, password, true);
    }

    const login = async (username, password, acceptTerms = false, openLoggingInModal = true) => {
        if (username.length === 0 || password.length === 0) return;
        setLoginDetails({username, password});

        if (openLoggingInModal) {
            openModal("Loading");
        }
        let data = {username, password};
        if (acceptTerms) data.acceptTandC = true;

        const res = await execute({method: "POST", data});

        if (res) {
            if (res.code === 200) {
                sendGA4Event("login", {method: "web"});

                try {
                    // Temporary fix to set the session cookie on development env
                    // if (IS_DEV) {
                    //     if (res?.data?.session?.store) {
                    //         setTimeout(() => {
                    //             instance.get(`/morpheus/${res.data.session.store}`).then(() => {
                    //                 if (res && res.redirect) {
                    //                     window.location = res.redirect;
                    //                 }
                    //             });
                    //         }, 1500);
                    //     }
                    // } else {
                    if (res && res.redirect) {
                        window.location = res.redirect;
                    }
                    // }

                    return true;
                } catch (e) {
                    //sendExceptionToSentry(e);
                    console.log(e);
                    return false;
                }
            } else {
                if (res.code === 428) {
                    const termsMessage = getTemporaryTerms(username);
                    openModal("AcceptTerms", {termsMessage, onAcceptTerms: acceptTermsLogin}, true);
                    return;
                } else {
                    if (res.redirect) {
                        if (res.redirect === LOGIN_URL) {
                            closeModal("Loading");

                            if (location.pathname !== LOGIN_URL) {
                                history.push(LOGIN_URL);
                            }

                            dispatch(setLoginError());
                        } else {
                            window.location = res.redirect;
                        }
                    } else {
                        window.location = LOGIN_URL;
                    }
                }
            }
        }

        return false;
    };

    return {isLoggingIn: status === "pending", login};
}


export function useLogout() {
    const {openModal, closeModal} = useModal();
    const {execute} = useRedPill("authorizedPaths.logout");

    const logout = async () => {
        closeModal("Logout");
        openModal("Loading");

        const res = await execute();

        try {
            if (res.code === 200) {
                window.location = res.redirect;
                return true;
            } else {
                closeModal("Loading");
            }
        } catch (e) {
            //sendExceptionToSentry(e);
            console.log(e);
            return false;
        }

        return false;
    };

    return {logout};
}
